// @ts-nocheck
import React from 'react';
import LeaderboardsManagement from '@/pages/admin-dashboard/LeaderboardsManagement';

const DemoLeaderboards: React.FC = () => {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-foreground">Rankings & Leaderboards Demo</h1>
        <p className="text-muted-foreground">Create and manage dynamic leaderboards with database-driven scoring rules</p>
      </div>
      <LeaderboardsManagement />
    </div>
  );
};

export default DemoLeaderboards;
